import React, { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const LkLayout = lazy(() => import('./LkLayout'));

const NewsPage = lazy(() => import('./NewsPage'));

const EventsPage = lazy(() => import('./EventsPage'));

const SupportPage = lazy(() => import('./SupportPage'));

const EventsSinglePage = lazy(() => import('./SingleEventsPage'));

const NewsSinglePage = lazy(() => import('./SingleNewsPage'));

const AccountPage = lazy(() => import('./AccountPage'));

const CartPage = lazy(() => import('./CartPage'));

const ProfilePage = lazy(() => import('./ProfilePage'));

const ProductsPage = lazy(() => import('./ProductsPage'));

const FinancePage = lazy(() => import('./FinancePage'));

const PartnersPage = lazy(() => import('./PartnersPage'));

const MarketingPage = lazy(() => import('./MarketingPage'));
const CalculatorPage = lazy(() => import('./CalculatorPage'));

const SingleSupportPage = lazy(() => import('./SingleSupportPage'));

const SpeedTestPage = lazy(() => import('./SpeedTestPage'));
const SignInPage = lazy(() => import('./SignInPage'));
const RegistrationPage = lazy(() => import('./RegistrationPage'));

const PromoPage = lazy(() => import('./PromoPage'));
const PromoDetailPage = lazy(() => import('./PromoDetailPage'));
const VpsPage = lazy(() => import('./VpsPage'));

// Несуществующий адрес: есть сохранённая сессия — в кабинет, нет — на вход.
const RedirectByAuth = () => {
  let hasSession = false;
  try {
    hasSession = !!localStorage.getItem('key_17');
  } catch {}
  return <Navigate to={hasSession ? '/lk/account' : '/auth/login'} replace />;
};

export const Routing = () => {
  return (
    <Routes>
      <Route path="/">
        <Route index element={<Navigate to="auth/login" />} />
      </Route>
      <Route path="calculator">
        <Route index element={<Navigate to="/auth/login" />} />
      </Route>

      <Route path="/auth">
        <Route index element={<Navigate to="registration" />} />
        <Route path="speed_test" element={<SpeedTestPage />} />
        <Route path="login" element={<SignInPage />} />
        <Route path="registration" element={<RegistrationPage />} />
      </Route>

      <Route path="/lk" element={<LkLayout />}>
        <Route index element={<Navigate to="account" />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="finance" element={<FinancePage />} />

        <Route path="cart" element={<CartPage />} />

        <Route path="partners" element={<PartnersPage />} />
        <Route path="partners/marketing" element={<MarketingPage />} />

        <Route path="calculator" element={<CalculatorPage />} />

        <Route path="profile" element={<ProfilePage />} />

        <Route path="events" element={<EventsPage />} />
        <Route path="events/:id" element={<EventsSinglePage />} />

        <Route path="news" element={<NewsPage />} />
        <Route path="news/:id" element={<NewsSinglePage />} />

        <Route path="support" element={<SupportPage />} />
        <Route path="support/:id" element={<SingleSupportPage />} />

        <Route path="promo" element={<PromoPage />} />
        <Route path="promo/:id" element={<PromoDetailPage />} />
        <Route path="vps" element={<VpsPage />} />

        <Route path="*" element={<RedirectByAuth />} />
      </Route>
      <Route path="*" element={<RedirectByAuth />} />
    </Routes>
  );
};
